import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PaginationControls } from 'wsm-paging-display';
import setPageInfo from '../actions/setPageInfo';

export const Pagination = () => {
	const pageInfo = useSelector((state) => state.pageInfo);
	const dispatch = useDispatch();
	const { currentPage, pageCount } = pageInfo;
	// Convert currentPage from the array index to the page number that displays
	const currentPageNumber = currentPage + 1;

	const updatePageNumber = (number) => {
		dispatch(
			setPageInfo({
				...pageInfo,
				currentPage: number
			})
		);
	};

	const handlePaginationClick = (number, event) => {
		event.preventDefault();
		// Reset currentPage to the array index when updating
		updatePageNumber(number - 1);
		window.scrollTo(0, 0);
	};

	return (
		<PaginationControls
			currentPageNumber={currentPageNumber}
			pageCount={pageCount}
			navAriaLabel="REVIEWS_PAGINATION"
			paginationLinkHandleClick={handlePaginationClick}
			paginationPreviousArrowProps={{
				ariaLabel: 'GO_TO_PREVIOUS_PAGE_OF_REVIEWS',
				icon: 'skinny-arrow-left',
				onClick: (event) =>
					handlePaginationClick(currentPageNumber - 1, event)
			}}
			paginationNextArrowProps={{
				ariaLabel: 'GO_TO_NEXT_PAGE_OF_REVIEWS',
				icon: 'skinny-arrow-right',
				onClick: (event) =>
					handlePaginationClick(currentPageNumber + 1, event)
			}}
			paginationLinkProps={{
				ariaLabel: 'GO_TO_PAGE_X_OF_REVIEWS'
			}}
		/>
	);
};
